import { adminFr } from "./admin";
import type { TranslationKey } from "./en";

const fr: Record<TranslationKey, string> = {
  ...adminFr,
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.switch": "Changer de langue",

  "brand.name": "Trimr",

  "nav.home": "Accueil",
  "nav.contact": "Contact",
  "nav.privacy": "Politique de confidentialité",
  "nav.login": "Se connecter",
  "nav.signup": "Commencer",
  "nav.myLinks": "Mes liens",
  "nav.signOut": "Déconnexion",
  "nav.admin": "Admin",
  "nav.backHome": "Retour à l'accueil",

  "home.seo.title": "Trimr — Des liens courts, faciles à partager",
  "home.seo.description":
    "Transformez n'importe quel lien long en lien court trimr.cc en quelques secondes. Ajoutez un mot de passe si besoin et voyez combien de fois il a été visité.",
  "home.seo.keywords":
    "lien court, raccourcisseur url, trimr, lien personnalisé, lien protégé",
  "home.hero.title": "Des liens courts, faciles à partager",
  "home.hero.text":
    "Transformez n'importe quel lien long en lien court en quelques secondes. Ajoutez un mot de passe si besoin.",
  "home.hero.placeholder": "Collez votre lien long ici…",
  "home.cta.dashboard": "Ouvrir mon tableau de bord",
  "home.cta.first": "Raccourcir",
  "home.cta.haveAccount": "J'ai déjà un compte",
  "home.feature.code.title": "Codes personnalisés",
  "home.feature.code.text":
    "Choisissez la fin de votre lien pour qu'il reste mémorisable, ou laissez-nous en générer un.",
  "home.feature.stats.title": "Nombre de clics",
  "home.feature.stats.text":
    "Voyez combien de fois votre lien a été visité, et d'où.",
  "home.feature.lock.title": "Protection par mot de passe",
  "home.feature.lock.text":
    "Ajoutez un mot de passe : le visiteur doit le saisir avant d'être redirigé.",
  "home.footer.rights": "Tous droits réservés",

  "auth.seo.description": "Connectez-vous à Trimr pour créer et gérer vos liens courts.",
  "auth.login.title": "Bon retour !",
  "auth.login.subtitle": "Connectez-vous pour retrouver vos liens.",
  "auth.signup.title": "Créez votre compte",
  "auth.signup.subtitle": "Quelques secondes suffisent pour créer votre premier lien.",
  "auth.email": "Adresse e-mail",
  "auth.password": "Mot de passe",
  "auth.submit.login": "Se connecter",
  "auth.submit.signup": "Créer mon compte",
  "auth.emailSent":
    "Un e-mail de confirmation vient d'être envoyé à {email}. Cliquez sur le lien qu'il contient pour activer votre compte.",
  "auth.backToLogin": "Retour à la connexion",
  "auth.haveAccount": "Déjà inscrit ?",
  "auth.noAccount": "Pas encore de compte ?",
  "auth.error.emailTaken": "Cette adresse e-mail est déjà utilisée.",
  "auth.error.badCredentials": "E-mail ou mot de passe incorrect.",

  "dash.seo.title": "Mes liens",
  "dash.seo.description": "Gérez vos liens courts et consultez leur nombre de clics.",
  "dash.title": "Mes liens",
  "dash.create.title": "Créer un nouveau lien",
  "dash.create.description":
    "Collez votre lien long. Tout le reste est facultatif.",
  "dash.field.target": "Adresse de destination",
  "dash.field.code": "Code personnalisé (facultatif)",
  "dash.field.title": "Nom interne (facultatif)",
  "dash.field.password": "Mot de passe (facultatif)",
  "dash.field.password.placeholder": "4 caractères minimum",
  "dash.field.code.placeholder": "promo-ete",
  "dash.field.title.placeholder": "Campagne été",
  "dash.create.submit": "Raccourcir →",
  "dash.search": "Rechercher dans vos liens…",
  "dash.empty": "Aucun lien pour le moment — créez le premier ci-dessus, il apparaîtra ici.",
  "dash.loadError": "Impossible de charger vos liens.",
  "dash.created": "Lien créé.",
  "dash.copied": "Lien copié.",
  "dash.copyFailed": "Copie impossible.",
  "dash.deleted": "Lien supprimé.",
  "dash.confirmDelete": "Supprimer définitivement le lien /{code} ?",
  "dash.badge.protected": "Protégé",
  "dash.badge.disabled": "Désactivé",
  "dash.toggle.aria": "Activer ou désactiver le lien",
  "dash.active": "Actif",
  "dash.delete": "Supprimer",
  "dash.copy": "Copier",
  "dash.stats": "Voir les clics",
  "dash.clicks": "{count} clics",
  "dash.clicks_one": "{count} clic",

  "detail.seo.title": "Nombre de clics",
  "detail.seo.description": "Détail des clics d'un lien court.",
  "detail.back": "Retour à mes liens",
  "detail.notFound": "Ce lien est introuvable.",
  "detail.copyShort": "Copier le lien court",
  "detail.total": "{count} clics au total",
  "detail.total_one": "{count} clic au total",
  "detail.noClicks": "Aucun clic sur les 30 derniers jours.",
  "detail.statsError": "Le détail des clics est indisponible pour le moment.",
  "detail.countries": "Pays",
  "detail.devices": "Appareils",
  "detail.referrers": "Sources",
  "detail.noData": "Aucune donnée.",
  "detail.chart.clicks": "clics",
  "preview.title": "Aperçu de partage",
  "preview.refresh": "Actualiser l'aperçu",
  "preview.refreshed": "Aperçu actualisé.",
  "preview.refreshError": "L'aperçu n'a pas pu être actualisé.",
  "preview.unavailable": "Aperçu indisponible pour ce site",
  "preview.showImage": "Miniature dans l'aperçu de partage",
  "preview.showImage.help":
    "Désactivée, l'aperçu WhatsApp/Facebook/Discord affiche seulement le titre et le domaine.",
  "preview.showImage.saved": "Aperçu de partage mis à jour.",
  "preview.showImage.error": "La modification n'a pas pu être enregistrée.",
  "preview.style.label": "Style de l’aperçu de partage",
  "preview.style.help":
    "Les applications de messagerie décident de la taille finale et peuvent conserver un ancien aperçu en cache.",
  "preview.style.standard": "Image standard",
  "preview.style.standard.help": "Utilise l’image du site de destination ou une image Trimr.",
  "preview.style.video": "Image style vidéo",
  "preview.style.video.help": "Affiche une grande image avec lecture. Elle ouvre le lien sans lecture intégrée.",
  "preview.style.none": "Sans image",
  "preview.style.none.help": "Affiche seulement le titre, la description et le domaine.",
  "preview.style.saved": "Style de l’aperçu de partage mis à jour.",


  "redirect.seo.title": "Redirection",
  "redirect.seo.description": "Ouverture d'un lien court.",
  "redirect.loading": "On vous y emmène…",
  "redirect.inactive.title": "Ce lien n'est plus actif",
  "redirect.inactive.text":
    "La personne qui l'a créé l'a désactivé. Vous pouvez lui demander un nouveau lien.",
  "redirect.password.title": "Ce lien est protégé",
  "redirect.password.named": "« {title} » est protégé par un mot de passe.",
  "redirect.password.generic": "Saisissez le mot de passe pour continuer.",
  "redirect.password.label": "Mot de passe",
  "redirect.password.submit": "Continuer",
  "redirect.password.wrong": "Mot de passe incorrect.",

  "notfound.seo.title": "404 - Page non trouvée",
  "notfound.seo.description": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "notfound.title": "Page non trouvée",
  "notfound.text": "Oups ! Cette page est introuvable. Elle a peut-être été déplacée ou le lien contient une erreur.",

  "contact.seo.title": "Contact",
  "contact.seo.description":
    "Une question sur Trimr ? Écrivez-nous à hello@trimr.cc, nous répondons rapidement.",
  "contact.title": "Nous contacter",
  "contact.subtitle":
    "Une question ou une idée ? Écrivez-nous, nous vous répondrons dans les plus brefs délais. Vous pouvez aussi nous écrire à hello@trimr.cc.",
  "contact.name": "Nom complet",
  "contact.name.placeholder": "Jean Dupont",
  "contact.email": "E-mail",
  "contact.email.placeholder": "jean.dupont@example.com",
  "contact.subject": "Sujet",
  "contact.subject.placeholder": "Sujet de votre message",
  "contact.message": "Message",
  "contact.message.placeholder": "Votre message...",
  "contact.send": "Envoyer le message",
  "contact.sending": "Envoi en cours...",
  "contact.security": "Vérification de sécurité",
  "contact.error.security": "Veuillez compléter la vérification de sécurité.",
  "contact.success": "Message envoyé avec succès ! Nous vous répondrons rapidement.",
  "contact.error.send": "Erreur lors de l'envoi du message. Veuillez réessayer.",
  "contact.validation.name.required": "Le nom est requis",
  "contact.validation.name.max": "Le nom ne peut pas dépasser 100 caractères",
  "contact.validation.email.invalid": "E-mail invalide",
  "contact.validation.email.max": "L'e-mail ne peut pas dépasser 255 caractères",
  "contact.validation.subject.required": "Le sujet est requis",
  "contact.validation.subject.max": "Le sujet ne peut pas dépasser 200 caractères",
  "contact.validation.message.min": "Le message doit contenir au moins 10 caractères",
  "contact.validation.message.max": "Le message ne peut pas dépasser 2000 caractères",

  "privacy.seo.title": "Politique de confidentialité",
  "privacy.seo.description":
    "Quelles informations Trimr conserve lorsque vous créez un lien court ou que quelqu'un le visite, et pendant combien de temps.",
  "privacy.seo.keywords":
    "confidentialité, données personnelles, RGPD, liens courts, trimr",
  "privacy.title": "Politique de confidentialité",
  "privacy.subtitle": "Comment Trimr traite vos informations, en langage simple",
  "privacy.s1.title": "1. Données que nous traitons",
  "privacy.s1.account.label": "Compte :",
  "privacy.s1.account.text":
    "votre adresse e-mail et la date de vos connexions, afin de sécuriser l'accès à vos liens.",
  "privacy.s1.links.label": "Liens créés :",
  "privacy.s1.links.text":
    "l'adresse de destination, le code court choisi, le titre facultatif, la date d'expiration éventuelle et, si vous en définissez un, l'empreinte chiffrée du mot de passe du lien. Le mot de passe lui-même n'est jamais conservé en clair.",
  "privacy.s1.clicks.label": "Clics :",
  "privacy.s1.clicks.text":
    "à chaque ouverture d'un lien court, nous enregistrons la date, l'adresse IP, le pays et la ville estimés, le fournisseur d'accès et le réseau, l'appareil, le système et le navigateur, la langue du navigateur, la page d'origine (référent) et un identifiant de visiteur. Cet identifiant est fourni par notre sous-traitant Fingerprint (fingerprint.com) et permet de distinguer les visiteurs et de détecter les abus. Ces informations techniques sont conservées 12 mois, puis supprimées automatiquement, et ne sont visibles que par les administrateurs du site.",
  "privacy.s1.security.label": "Sécurité du site :",
  "privacy.s1.security.text":
    "des journaux techniques (adresse IP, navigateur, pages consultées, tentatives de connexion) sont conservés pour détecter les robots et les abus.",
  "privacy.s2.title": "2. Pourquoi ces données",
  "privacy.s2.i1": "Faire fonctionner la redirection des liens courts — exécution du service.",
  "privacy.s2.i2":
    "Montrer aux créateurs de liens combien de fois leur lien a été visité — intérêt légitime à connaître la portée de leurs propres liens.",
  "privacy.s2.i3":
    "Protéger le service contre les robots, les abus et les contenus malveillants — intérêt légitime à la sécurité.",
  "privacy.s2.note":
    "Les nombres de clics sont regroupés : ils ne permettent jamais d'identifier nominativement les personnes qui ouvrent un lien.",
  "privacy.s3.title": "3. Durées de conservation",
  "privacy.s3.i1": "Compte et liens : tant que votre compte existe.",
  "privacy.s3.i2":
    "Détail des clics : conservé pendant la durée de vie du lien ; la suppression d'un lien supprime aussi ses clics.",
  "privacy.s3.i3": "Journaux techniques de sécurité : durée limitée, purgée automatiquement.",
  "privacy.s4.title": "4. Destinataires",
  "privacy.s4.text":
    "Les données ne sont pas vendues. Elles sont traitées par des prestataires techniques agissant pour notre compte : hébergement et base de données, envoi d'e-mails transactionnels, protection anti-robot et service d'estimation de la localisation à partir de l'adresse IP.",
  "privacy.s5.title": "5. Vos droits",
  "privacy.s5.p1":
    "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition, ainsi que d'un droit à la portabilité de vos données. Vous pouvez supprimer vous-même un lien et son historique de clics depuis votre tableau de bord.",
  "privacy.s5.p2.before": "Pour exercer vos droits, écrivez à privacy@trimr.cc ou utilisez la page",
  "privacy.s5.p2.link": "Contact",
  "privacy.s5.p2.after":
    ". Vous pouvez également introduire une réclamation auprès de la CNIL.",
  "privacy.s6.title": "6. Cookies",
  "privacy.s6.text":
    "Trimr n'utilise pas de cookies publicitaires et ne partage rien avec des sociétés de marketing. Seuls des éléments strictement nécessaires sont utilisés : maintien de votre session lorsque vous êtes connecté et protection anti-robot.",
};

export default fr;
